export const data = {
  orderConfirm: {
    en: {
      '请输入订单编号进行查询': 'Pls input order no. for query',
    },
    cn: {
      '请输入订单编号进行查询': '请输入订单编号进行查询',
    },
  },
  address: {
    en: {
      "添加成功": "successful",
      "编辑成功": "successful",
      "最多添加X个观演人哦": "Add max. X audience(s)",
      '请输入11位手机号码': 'Pls input phone no. of 11 digits',
      '请输入18位身份证号码': 'Pls input Id card no. of 18digits',
      '身份证': 'ID Card',
      '姓名': 'Name',
      '请输入观演人姓名': 'Pls input visitor\'s name',
      "重新获取": "reacquire",
      '编辑观演人': 'Edit visitor',
      "请填写正确的手机号": "Pls properly input phone no.",
      '添加观演人': 'Add visitor',
      '验证码不能为空': 'Identifying code shall not be vacant',
      '您要取消该订单吗': 'Are you sure you want to cancel this order?',
      '您要删除该取票人信息吗': 'Are you sure to delete the information of person taking ticket?',
      '详细地址长度不能超过50个字符': 'Detailed address must be less than 50 characters!',
      '请输入正确的手机号码': 'Pls properly input phone no.',
      '手机号不能为空': 'Phone no. shall not be vacant',
      '请您输入完整的地区信息': 'Pls input complete area info.!',
      '不允许出现X先生/X小姐详情阅读温馨提示': '不允许出现X先生/X小姐等字样，请务必实名输入，详情阅读温馨提示',
      '姓名长度不能超过20个字符': 'Name must be less than 20 characters',
      '姓名不能为空': 'Name shall not be vacant',
      '请输入正确的身份证号码': 'Pls properly input ID Card No.!',
      '身份证号码不能为空': 'ID Card No. shall not be vacant',
      "请输入取票人姓名": "Pls input name of person taking ticket",
      '固定号码': 'Fixed-line phone no',
      '手机号码': 'Phone number',
      '收货地址': 'Shipping Address',
      '修改地址成功': 'Successfully modified address',
      '新建收货地址': 'Add new shipping address',
      '删除': 'Delete',
      '设为默认': 'Set as default',
      "请输入关键词": "Pls input key words",
      '确认': 'Confirm',
      '取消': 'Cancel',
      '收货人': 'Consignee',
      '手机号': 'Phone No',
      '所在地区': 'Region',
      '详细地址': 'Detailed \r\n Address',
      '邮政编码': 'Post Code',
      '地址标签': 'Address Tag',
      '家': 'Home',
      '公司': 'Co.',
      '学校': 'Sch',
      '设置为默认收货地址': 'Set as default shipping address',
      'addressTips': 'Reminder: this address is recommended by default for each order',
      'notice': 'Warm Tip: The Postal Administration informs that since September 01, 2018, the name of the recipient as well as the name of the sender on the logistics information of all express deliveries must be filled in with the real name, and it is prohibited to fill in with surnames and other characters. Please fill in the recipient information in your real name, otherwise no delivery will be made. Thank you for your cooperation!',
      '温馨提示': 'Reminder',
      '保存地址': 'Save Address',
      '已经到底了': 'No more updates',
      '详细地址提示': 'Street, house number, community, building number and room number, etc.',
      '请选择': 'Please select',
      '请输入11位手机号': 'Please enter 11-digit phone number',
      '验证码': 'Identifying code',
      '请输入验证码': 'Pls input identifying code',
      '获取验证码': 'Obtain',
      '重新发送': 'Send again',
      '输入短信验证码': 'Please enter SMS verification code',
      '待完善': '待完善',
      '下一步': '下一步',
      '新的支付密码': 'New payment password',
      '确认新的支付密码': 'Confirm new payment password',
      '输入4位数字密码': 'Enter 4 numerical digits password',
      '再次输入4位数字密码': 'Enter 4 numerical digits password again',
      '确认设置': 'Confirm setup',
      '请输入手机号码': 'Pls input phone number ',
      'checkCode': 'Check code has been sent to your phone, pls check',
      'freightPay': 'The expense of pay product shall be independently given to deliveryman, which is not included in total price ',
      '更多地址': 'More address',
      '新建地址': 'Add New Address',
      '编辑地址': 'Edit address',
      '请填写收货人姓名': 'Please fill in the consignee name',
      '请填写收货人手机号码': 'Please fill in the consignee mobile number',
      '配送至': 'Delivery Address',
      '收货地址删除成功': 'Successful',
      '收货地址删除失败': 'Failed',
      '最多只能输入5个字': 'Only input five words',
      '确定': 'Confirm',
      '编辑': '编辑',
      '确认删除该地址吗': 'Are you sure to delete this address?',
      '再想想': 'Think twice',
      '修改的信息还未保存': 'You haven’t saved the alteration.',
      '确认现在返回么': 'Are you sure to return now?',
      '您还没有收货地址哦': 'You don\'t have delivery address ',
      '快去新建吧': 'Establish now ！~',
      '修改': 'Alter',
      '您要删除该收货地址吗': 'Are you sure to delete this delivery address?',
      'newAddressError': 'Mr./Mrs. X is forbidden. Pls fill in real information. Read prompt for details.',
      '收货人不能为空': 'Consignee shall not be vacant',
      '所在地区不能为空': 'Location shall not be vacant',
      'mobileError': 'Phone number format is wrong, pls re-enter',
      '手机号码不能为空': 'Phone number shall not be vacant',
      '详细地址不能为空': 'Detailed address shall not be vacant',
      '默认': 'Default',
      '请选择地址': 'Please select address',
      '请输入邮政编码': 'pls input zip code',
      '物流信息': 'Logistics info.',
    },
    cn: {
      "最多添加X个观演人哦": "最多添加X个观演人哦",
      '请输入11位手机号码': '请输入11位手机号码',
      '请输入18位身份证号码': '请输入18位身份证号码',
      '身份证': '身份证',
      '姓名': '姓名',
      '请输入观演人姓名': '请输入观演人姓名',
      '编辑观演人': '编辑观演人',
      '添加观演人': '添加观演人',
      '验证码不能为空': '验证码不能为空',
      '您要取消该订单吗': '您要取消该订单吗?',
      '您要删除该取票人信息吗': '您要删除该取票人信息吗?',
      '详细地址长度不能超过50个字符': '详细地址长度不能超过50个字符!',
      '请输入正确的手机号码': '请输入正确的手机号码',
      '手机号不能为空': '手机号不能为空',
      '请您输入完整的地区信息': '请您输入完整的地区信息!',
      '不允许出现X先生/X小姐详情阅读温馨提示': '不允许出现X先生/X小姐等字样，请务必实名输入，详情阅读温馨提示',
      '姓名长度不能超过20个字符': '姓名长度不能超过20个字符',
      '姓名不能为空': '姓名不能为空',
      '请输入正确的身份证号码': '请输入正确的身份证号码!',
      '身份证号码不能为空': '身份证号码不能为空',
      '固定号码': '固定号码',
      '手机号码': '手机号码',
      '请输入邮政编码': '请输入邮政编码',
      '请选择地址': '请选择地址',
      '修改地址成功': '修改地址成功',
      '默认': '默认',
      '收货地址': '收货地址',
      '新建收货地址': '新建收货地址',
      '删除': '删除',
      '设为默认': '设为默认',
      '确认': '确认',
      '取消': '取 消',
      '收货人': '收货人',
      '手机号': '手机号',
      '所在地区': '所在地区',
      '详细地址': '详细地址',
      '邮政编码': '邮政编码',
      '地址标签': '地址标签',
      '家': '家',
      '公司': '公司',
      '学校': '学校',
      '设置为默认收货地址': '设置为默认收货地址',
      'addressTips': '提醒：每次下单会默认推荐使用该地址',
      '温馨提示': '温馨提示',
      'notice': '温馨提示：2018.09.01起，邮管局通知：所有快递物流信息上收件人以及寄件人信息禁止出现X先生/X小姐等字样，务必实名填写。请您实名填写收件信息，否则将不予发货，谢谢配合！',
      '保存地址': '保存地址',
      '已经到底了': '已经到底了',
      '详细地址提示': '街道、门牌号、小区、楼栋号、单元室等',
      '请选择': '请选择',
      '请输入11位手机号': '请输入11位手机号',
      '验证码': '验证码',
      '请输入验证码': '请输入验证码',
      '获取验证码': '获取验证码',
      '重新发送': '重新发送',
      '输入短信验证码': '输入短信验证码',
      '待完善': '待完善',
      '下一步': '下一步',
      '新的支付密码': '新的支付密码',
      '确认新的支付密码': '确认新的支付密码',
      '输入4位数字密码': '输入4位数字密码',
      '再次输入4位数字密码': '再次输入4位数字密码',
      '确认设置': '确认设置',
      '请输入手机号码': '请输入手机号码',
      'checkCode': '校验码已发送至您的手机，请查收',
      '输入的密码4位数字不能相同或连续': '输入的密码4位数字不能相同或连续',
      '请再次输入四位数字支付密码': '请再次输入四位数字支付密码',
      'freightPay': '付费产品的费用需单独支付给配送员，此处不计入总价',
      '更多地址': '更多地址',
      '新建地址': '新建地址',
      '编辑地址': '编辑地址',
      '请填写收货人姓名': '请填写收货人姓名',
      '请填写收货人手机号码': '请填写收货人手机号码',
      '配送至': '配送至',
      '收货地址删除成功': '收货地址删除成功',
      '收货地址删除失败': '收货地址删除失败',
      '最多只能输入5个字': '最多只能输入5个字',
      '确定': '确 定',
      '编辑': '编辑',
      '确认删除该地址吗': '确认删除该地址吗？',
      '再想想': '再想想',
      '修改的信息还未保存': '修改的信息还未保存,',
      '确认现在返回么': '确认现在返回么？',
      '您还没有收货地址哦': '您还没有收货地址哦',
      '快去新建吧': '快去新建吧！~',
      '修改': '修改',
      '您要删除该收货地址吗': '您要删除该收货地址吗?',
      'newAddressError': '不允许出现X先生/X小姐等字样，请务必实名填写，详情阅读温馨提示',
      '收货人不能为空': '收货人不能为空',
      '所在地区不能为空': '所在地区不能为空',
      'mobileError': '手机号码格式不对，请重新输入',
      '手机号码不能为空': '手机号码不能为空',
      '详细地址不能为空': '详细地址不能为空',
      '物流信息': '物流信息',
    },
  },
  card: {
    en: {
      '使用福利卡抵扣': 'Use bonus card for deduction',
      '绑定福利卡': 'Bind benefit card',
      'cardPWD': 'Please enter 16-digit card password, not case sensitive',
      'cardPWD1': 'Please enter 16-digit card password',
      'cardPWD2': 'not case sensitive',
      '立即绑定': 'Bind now',
      '扫码绑定': 'Scan to bind',
      '可用次数': 'Available times',
      '可用余额': 'Available Balances',
      '次': 'Times',
      '卡号': 'Card No.',
      '有效期至': 'Expiration date',
      '确认绑定': 'Confirm bind',
      '确认绑定福利卡': 'Confirm binding benefit card',
      '请输入正确的卡密': 'Please enter correct card password',
      '绑定福利卡成功': 'Successful',
      '抵扣': 'Deduction',
      '请输入16位卡密码': 'Pls input card password of 16 digits',
      '确认绑定这张福利卡吗': 'Are you sure to bind this bonus card',
      '请输入四位数字支付密码': 'Pls input password of 4 digits',
      '输入的密码4位数字不能相同或连续': '4-digit password cannot be same or continuous',
      '请再次输入四位数字支付密码': 'Pls input password of 4 digits again',
      'checkPayPwd': 'Password is inconsistent, please retype it',
      '暂无可用余额': 'No balances available',
      '暂无可用积分': 'No points available temporarily',
      '福豆': 'FuDou',
      '无可用卡': 'No available card',
    },
    cn: {
      '使用福利卡抵扣': '使用福利卡抵扣',
      '绑定福利卡': '绑定福利卡',
      'cardPWD': '请输入16位卡密，卡密不区分大小写',
      'cardPWD1': '请输入16位卡密',
      'cardPWD2': '卡密不区分大小写',
      '立即绑定': '立即绑定',
      '扫码绑定': '扫码绑定',
      '可用次数': '可用次数',
      '可用余额': '可用余额',
      '次': '次',
      '卡号': '卡号',
      '有效期至': '有效期至',
      '确认绑定': '确认绑定',
      '确认绑定福利卡': '确认绑定福利卡',
      '请输入正确的卡密': '请输入正确的卡密',
      '绑定福利卡成功': '绑定福利卡成功',
      '抵扣': '抵扣',
      '请输入16位卡密码': '请输入16位卡密码',
      '确认绑定这张福利卡吗': '确认绑定这张福利卡吗',
      '请输入四位数字支付密码': '请输入四位数字支付密码',
      'checkPayPwd': '两次输入不一致,请重新输入',
      '暂无可用余额': '暂无可用余额',
      '暂无可用积分': '暂无可用积分',
      '无可用卡': '无可用卡',
      '福豆': '福豆',
    },
  },
  user: {
    en: {
      '自动扣款': 'Auto deduction',
      '支付设置': 'Payment settings',
    },
    cn: {
      '自动扣款': '自动扣款',
      '支付设置': '支付设置',
    },
  },
  my: {
    en: {
      "抱歉,当前场次暂不可售": "Not currently available for sale ",
      "抱歉，当前场次不可售": "Not currently available for sale ",
      "抱歉,当前无可选场次": "No session",

      '热门': 'Popular',
      '电影票话剧票健身': 'Cinema ticket, drama ticket and fitness',
      '收起地址': 'Fold the address',
      '演出详情': 'Show details',
      '禁止携带物品说明': 'Notes on restricted items',
      '寄存说明': 'Storage instructions',
      '演出销售结束时间': 'End time',
      '演出开售时间': 'Start time',
      '自动取票': 'Self-service ticket',
      '电子票入场提示': 'E-ticket entrance prompt',
      '入场说明': 'Admission instructions',
      '退换政策': 'Exchange policy',
      '儿童购票说明': 'Child ticket instructions',
      '实名制购票': 'Real-name ticketing',
      '是否支持选座': 'Is it available for choosing a seat',
      "共需X位观演人": "Need X visitor(s) in total",
      '发票说明': 'Invoice instructions',
      '因福利卡券在购买时': 'DF has issued invoice to your employer when coupons are sold, so DF is unable to issue invoice again if you use coupon to pay the bill. We are sorry for inconvenience.',
      '已经收到您的缺票登记': 'Your ticket missing registration has been received',
      '无座': 'No seat',
      '暂无观演人信息': 'There is no information about the viewer at present',
      '添加': 'add',
      '请添加观演人信息': 'Please add information about the viewer',
      '暂无地址': 'Pls add add.',
      '取票地址': 'Ticket address',
      '邮管局通知所有快递配送物流信': 'The Postal Administration informs that since September 01, 2018, the name of the recipient as well as the name of the sender on the logistics information of all express deliveries must be filled in with the real name, and it is prohibited to fill in with surnames and other characters. Please fill in the recipient information in your real name, otherwise no delivery will be made. Thank you for your cooperation!',
      '暂无收货地址': 'There is no shipping address at present',
      '请添加收货地址信息': 'Please add shipping address information',
      '退款时间': 'Refund time',
      '人工退款': 'Manual refund',
      '退款失败': 'Failed',
      '退款申请失败': 'Refund application failed',
      '退款成功': 'Successful',
      '退款申请成功': 'Refund application successful',
      '出票成功': 'Successful',
      '出票中': 'Issuing',
      '已完成': 'Done',
      '已取消': 'Cancelled',
      '已支付': 'Paid',
      '待支付': 'To be paid',
      '全部状态': 'All status',
      '出票成功后手机号': 'Home delivery is available once ticket is issued. Pls provide Damai order No., name of person taking ticket and phone No. to get ticket',
      '请带好身份证凭身份证入场': 'Please bring your ID card and enter with your ID card, or exchange paper tickets at the performance venue before entering',
      '哦': 'oh',
      '电子码': 'Electronic code',
      '中查看': 'after placing',
      '修改支付密码': 'Modify payment password',
      '修改密码': 'Change password',
      '账户绑定': 'Bind the account',
      '兑换票师傅卡券': 'Exchange of piaoshifu card coupon',
      '我的问诊单': 'My consultation sheet',
      '体检订单': 'ME order',
      '健身订单': 'Fitness order',
      '旅游景点订单': 'Attraction order',
      '玩乐订单': 'Entertainment order',
      '电子券订单': 'E-coupon order',
      '购物订单': 'Shopping order',
      '电影订单': 'Movie order',
      '我的优惠券': 'My coupon',
      '我的东方福利卡': 'My DONGFANGFULI.COM card',
      '东方福利网公众号': '【DF official account】',
      '微信扫一扫东福公众号': 'Use WeChat to scan Dongfu WeChat official account',
      '请前往': 'Please go to',
      '大麦订单号': 'Damai order No',
      '剩余支付时间': 'Payment time left',
      '暂不取消': 'Undecided',
      '去逛逛': 'Go now',
      '还没有您的演出订单哦': 'You have no performance order',
      '立即支付': 'Pay now',
      '不退不换': 'No refund or change',
      '含运费': 'Freight included',
      '总计福豆': 'Total(FuDou)',
      '单价福豆': 'Unit Price(FuDou)',
      '票品详情': 'Ticket details',
      '该票务由大麦网提供': 'Ticket offered by Damai',
      '返回演出详情': 'Return to performance details',
      '再看看': 'Check more',
      '确认提交': 'Confirm',
      '为了不影响您的观演观演人信息': 'In order not to affect your view of performance, please verify the consignee and viewer information you entered and the tickets cannot be returned and exchanged once sold',
      '为了不影响您的观演不支持退换': 'In order not to affect your view of performance, please verify the consignee information you entered and the tickets cannot be returned and exchanged once sold',
      '为了不影响您的观演请核实': 'In order not to affect your view of performance, please verify the consignee and viewer information you entered and the tickets cannot be returned and exchanged once sold',
      '为了不影响您的观演': 'In order not to affect your view of performance, please verify the ticket picker information you entered and the tickets cannot be returned and exchanged once sold',
      '信息核实': 'Ticket details',
      '尊敬的用户': 'Warm tips: Dear users, the tickets cannot be returned and exchanged once sold',
      '需支付': 'To be paid',
      '运费': 'Freight',
      '优惠福豆': 'Discount(FuDou)',
      "抱歉，当前票档不可售": "Sold out",
      '订单信息': 'Order information',
      '取票信息': 'Ticket info',
      '查看所有演出': 'View all shows',
      '抱歉没有找到相关的演出哦': 'Sorry, no relevant shows found',
      '使用微信扫码立即选座': 'Use Wechat scan,Pls select seat',
      '提交': 'Submit',
      '一旦有票': 'We will immediately send SMS to you once ticket is available',
      '因合作商调整': 'Reminder:Unit of ticket rate is RMB due to the change of cooperators',
      '张': 'piece',
      '合计': 'Total',
      '单': 'single',
      '每笔订单限购': 'tickets are limited',
      '元套票包含': 'RMB package, including',
      '份': 'Portion',
      '票档': 'Ticket level',
      '场次': 'Session',
      '秒': 'sec',
      '分': 'Credit',
      '时': '时',
      '距离开售还有': 'days left before the sale',
      '暂不支持查看': 'Not supported View',
      '本商品为预售商品': 'This product is a pre-sale product, and you will be notified as soon as possible after formal issue',
      '待开售': 'To be sold',
      '缺票登记': 'Stockout registration',
      '立即选座': 'Pls select seat',
      '立即购票': 'Buy now',
      '演出票未发货您耐心等待': 'Ticket is not delivered, pls wait patiently~',
      '抱歉暂无数据': 'Sorry, there is no data yet',
      '快递公司': 'Express company',
      '普通配送': 'Ordinary delivery',
      '快递方式': 'Express delivery method',
      '物流详情': 'Logistics details',
      '演出订单': 'Performance order',
      '演出首页': 'Home',
      '如有疑问请联系': 'Pls ask for help if required',
      '当前城市暂无演出信息': 'At present, there is no performance information in the city',
      '电子票': 'E-ticket',
      '自助机取票': 'Self-service ticketing',
      '上门自取': 'Home delivery',
      '快递配送': 'Delivery',
      '身份证电子票': 'ID card e-ticket',
      '取票方式': 'Way to take ticket',
      '最近开场': 'Latest session',
      '综合排序': 'Comprehensive ranking',
      '全国热映': 'Nationwide hot showing',
      '到第': 'To',
      '页': 'Page',
      '下一页': 'Next page',
      '缺票登记成功': 'Successful ticket registration',
      '场馆': 'Performance venue',
      '暂无取票人信息': 'There is no information about the ticket picker at present',
      '取票人': 'Person taking ticket',
      '观演人': 'Audience',
      '在线客服': 'Online customer service',
      '微信扫一扫关注东福': 'Wechat scanning to follow DF',
      '周一至周日': 'From Mon. to Sun.',
      '周一至周五': 'From Mon. to Fri.',
      '贴心客服热线': 'Customer service hotline',
      '回到顶部': 'Top',
      '票价': 'Ticket rate',
      '自定义': 'Customized',
      '时间': 'Time',
      '分类': 'CAT',
      '更多': 'More',
      '城市': 'City',
      '已选': 'Selected',
      '自动扣款': 'Auto deduction',
      '支付设置': 'Payment settings',
      '本周内': 'Within this week',
      '本周末': 'This weekend',
      '本月内': 'Within this month',
      '支付申请成功': 'Pay application successful',
      '支付申请失败': 'Pay application failed',
      '支付失败': 'Failed',
      '点卡支付': 'Points card pay',
      '次卡支付': 'Times card pay',
      '丰米': '丰米',
      '酒花': '酒花',
      '支付宝支付': 'Alipay',
      '元': 'yuan',
      '微信支付': 'Wechat Pay',
      '银联': 'Unionpay',
      '微信JSAPI': 'Wechat JSAPI',
      '支付宝WAP': 'Alipay WAP',
      '企业微信JSAPI': 'Wechat enterprise',
      '积分支付': 'Points pay',
      '分销渠道': 'Distribution channel',
      '企业积分': 'Enterprise points',
      '微信小程序支付': 'WeChat Applet payment',
      '微信H5': 'WeChat H5',
      '微信APP': 'WeChat APP',
      '支付宝': 'Alipay',
      '支付宝WAP': 'Alipay WAP',
      '支付宝APP': 'Alipay APP',
      '看台': 'Stand',
      '删除地址成功': 'The Address Has Been Deleted',
      '请更改收货地址信息': 'Please Change the Shipping Address Information',
      '请填写快递公司': 'Please Fill in the Courier Company, Such as“ XX Express"',
      '取消订单成功': 'Successful',
    },
    cn: {
      "共需X位观演人": "共需X位观演人",
      '热门': '热门',
      '电影票话剧票健身': '电影票话剧票健身',
      '收起地址': '收起地址',
      '演出详情': '演出详情',
      '禁止携带物品说明': '禁止携带物品说明',
      '寄存说明': '寄存说明',
      '演出销售结束时间': '演出销售结束时间',
      '演出开售时间': '演出开售时间',
      '自动取票': '自动取票',
      '电子票入场提示': '电子票入场提示',
      '入场说明': '入场说明',
      '退换政策': '退换政策',
      '儿童购票说明': '儿童购票说明',
      '实名制购票': '实名制购票',
      '是否支持选座': '是否支持选座',
      '发票说明': '发票说明',
      '因福利卡券在购买时': '因福利卡券在购买时，我司已为您公司开具过发票，所以使用卡券全额支付的订单，我们无法再为您开具发票，由此给您带来的不便，敬请谅解。',
      '已经收到您的缺票登记': '已经收到您的缺票登记',
      '无座': '无座',
      '暂无观演人信息': '暂无观演人信息',
      '添加': '添加',
      '请添加观演人信息': '请添加观演人信息',
      '暂无地址': '暂无地址',
      '取票地址': '取票地址',
      '邮管局通知所有快递配送物流信': '2018.09.01起，邮管局通知：所有快递配送物流信息上收件人以及寄件人信息禁止出现X先生/X小姐等字样，务必实名输入。请您实名输入收件信息，否则不予发货，谢谢配合！',
      '暂无收货地址': '暂无收货地址',
      '请添加收货地址信息': '请添加收货地址信息',
      '退款时间': '退款时间',
      '人工退款': '人工退款',
      '退款失败': '退款失败',
      '退款申请失败': '退款申请失败',
      '退款成功': '退款成功',
      '退款申请成功': '退款申请成功',
      '出票成功': '出票成功',
      '出票中': '出票中',
      '已完成': '已完成',
      '已取消': '已取消',
      '已支付': '已支付',
      '待支付': '待支付',
      '全部状态': '全部状态',
      '出票成功后手机号': '出票成功后，可上门自取。取票时，请提供大麦订单号、取票人姓名、手机号',
      '请带好身份证凭身份证入场': '请带好身份证,凭身份证入场,或到演出地点兑换纸质票后入场',
      '哦': '哦',
      '电子码': '电子码',
      '中查看': '中查看',
      '修改支付密码': '修改支付密码',
      '修改密码': '修改密码',
      '账户绑定': '账户绑定',
      '兑换票师傅卡券': '兑换票师傅卡券',
      '我的问诊单': '我的问诊单',
      '体检订单': '体检订单',
      '健身订单': '健身订单',
      '旅游景点订单': '旅游景点订单',
      '玩乐订单': '玩乐订单',
      '电子券订单': '电子券订单',
      '购物订单': '购物订单',
      '电影订单': '电影订单',
      '我的优惠券': '我的优惠券',
      '我的东方福利卡': '我的东方福利卡',
      '东方福利网公众号': '【东方福利网公众号】',
      '微信扫一扫东福公众号': '微信扫一扫东福公众号',
      '请前往': '请前往',
      '大麦订单号': '大麦订单号',
      '剩余支付时间': '剩余支付时间',
      '暂不取消': '暂不取消',
      '去逛逛': '去逛逛',
      '还没有您的演出订单哦': '还没有您的演出订单哦~',
      '立即支付': '立即支付',
      '不退不换': '不退不换',
      '含运费': '含运费',
      '总计福豆': '总计(福豆)',
      '单价福豆': '单价(福豆)',
      '票品详情': '票品详情',
      '该票务由大麦网提供': '该票务由大麦网提供',
      '返回演出详情': '返回演出详情',
      '再看看': '再看看',
      '确认提交': '确认提交',
      '为了不影响您的观演观演人信息': '为了不影响您的观演，请核实您输入的收货人及观演人信息 票品一经售出不支持退换',
      '为了不影响您的观演不支持退换': '为了不影响您的观演，请核实您输入的收货人信息 票品一经售出 不支持退换',
      '为了不影响您的观演请核实': '为了不影响您的观演，请核实您输入的取票人及观演人信息 票品一经售出不支持退换',
      '为了不影响您的观演': '为了不影响您的观演，请核实您输入的取票人信息 票品一经售出 不支持退换',
      '信息核实': '信息核实',
      '尊敬的用户': '温馨提示：尊敬的用户，票品一经出售不支持退换',
      '需支付': '需支付',
      '运费': '运费',
      '优惠福豆': '优惠(福豆):',
      '订单信息': '订单信息',
      '取票信息': '取票信息',
      '查看所有演出': '查看所有演出',
      '抱歉没有找到相关的演出哦': '抱歉~没有找到相关的演出哦',
      '使用微信扫码立即选座': '使用微信扫码,立即选座',
      '提交': '提交',
      '一旦有票': '一旦有票，我们将第一时间用短信通知您',
      '因合作商调整': '温馨提示：因合作商调整，票价可能显示为人民币',
      '张': '张',
      '合计': '合计',
      '单': '单',
      '每笔订单限购': '每笔订单限购',
      '元套票包含': '元套票,包含',
      '份': '份',
      '票档': '票档',
      '场次': '场次',
      '秒': '秒',
      '分': '分',
      '时': '时',
      '距离开售还有': '距离开售还有',
      '本商品为预售商品': '本商品为预售商品，正式开票后将第一时间通知你',
      '待开售': '待开售',
      '缺票登记': '缺票登记',
      '立即选座': '立即选座',
      '立即购票': '立即购票',
      '演出票未发货您耐心等待': '演出票未发货，您耐心等待~',
      '抱歉暂无数据': '抱歉，暂无数据！',
      '快递公司': '快递公司:',
      '普通配送': '普通配送',
      '快递方式': '快递方式：',
      '物流详情': '物流详情',
      '演出订单': '演出订单',
      '演出首页': '演出首页',
      '如有疑问请联系': '如有疑问请联系:',
      '当前城市暂无演出信息': '当前城市暂无演出信息',
      '电子票': '电子票',
      '自助机取票': '自助机取票',
      '上门自取': '上门自取',
      '快递配送': '快递配送',
      '身份证电子票': '身份证电子票',
      '取票方式': '取票方式',
      '最近开场': '最近开场',
      '综合排序': '综合排序',
      '全国热映': '全国热映',
      '到第': '到第',
      '页': '页',
      '下一页': '下一页',
      '缺票登记成功': '缺票登记成功',
      '场馆': '场馆',
      '暂无取票人信息': '暂无取票人信息',
      '取票人': '取票人',
      '观演人': '观演人',
      '在线客服': '在线客服',
      '微信扫一扫关注东福': '微信扫一扫 关注东福',
      '周一至周日': '周一至周日',
      '周一至周五': '周一至周五',
      '贴心客服热线': '贴心客服热线',
      '回到顶部': '回到顶部',
      '票价': '票价:',
      '自定义': '自定义',
      '时间': '时间:',
      '分类': '分类:',
      '更多': '更多',
      '城市': '城市:',
      '已选': '已选:',
      '自动扣款': '自动扣款',
      '支付设置': '支付设置',
      '本周内': '本周内',
      '本周末': '本周末',
      '本月内': '本月内',
      '支付申请成功': '支付申请成功',
      '支付申请失败': '支付申请失败',
      '支付失败': '支付失败',
      '点卡支付': '点卡支付',
      '次卡支付': '次卡支付',
      '丰米': '丰米',
      '酒花': '酒花',
      '支付宝支付': '支付宝支付',
      '元': '元',
      '微信支付': '微信支付',
      '银联': '银联',
      '微信JSAPI': '微信JSAPI',
      '支付宝WAP': '支付宝WAP',
      '企业微信JSAPI': '企业微信JSAPI',
      '积分支付': '积分支付',
      '分销渠道': '分销渠道',
      '企业积分': '企业积分',
      '微信小程序支付': '微信小程序支付',
      '微信H5': '微信H5',
      '微信APP': '微信APP',
      '支付宝': '支付宝',
      '支付宝WAP': '支付宝WAP',
      '支付宝APP': '支付宝APP',
      '看台': '看台',
      '删除地址成功': '删除地址成功',
      '请更改收货地址信息': '请更改收货地址信息',
      '请填写快递公司': '请填写快递公司,如“xx快递”',
      '取消订单成功': '取消订单成功',
    },
  },
  home: {
    en: {
      '抱歉您的订单提交失败': '抱歉，您的订单提交失败！',
      '编辑收货地址': 'Edit delivery address',
      '新增收货地址': 'Add new shipping address',
      '当前已选城市': 'City selected',
      '物流公司': 'Logistics company',
      '快递编号': 'Express code',
      '配送方式': 'Mode of Distribution',
      '内发货': '内发货',
      '至': 'to',
      '现在下单': '现在下单，商品将在',
      '再想想': 'Think twice',
      '删除后将无法找回订单': 'The order cant be retrieved once it is deleted. Are you sure to delete the order?',
      '删除订单': 'Delete order',
      '更多': 'More',
      '专享价': 'Exclusive price',
      '京东优选分类': '京东优选分类',
      '楼层导航': 'Floor navigation',
      '营业时间': 'Business hours',
      '电话': 'Cellphone',
      '地址': 'Address',
      '使用微信扫码立即体验随心兑': 'Use Wechat scan to enjoy go-as-you-please exchange',
      '微信扫一扫': 'Wechat scan',
      '随心兑': 'exchange',
      '可用，需到店使用': '可用，需到店使用',
      '消费': '消费',
      '折': 'off',
      '兑': '兑',
      '品牌故事': 'Brand story',
      '适用门店': 'Available shops',
      '商品': 'Product',
      '品牌详情': 'Brand details',
      '生日汇': 'Birthday',
      '购买': 'Buy',
      '在线支付': 'Online payment',
      '抵用券': 'Voucher',
      '券': 'Voucher',
      '品牌介绍': 'Brand introduction',
      '图书分类': 'Book category',
      '起': 'Start',
      '查看更多': 'View more',
      '热门推荐': 'Recommendation',
      '起发货': 'Delivery from',
      '热门商品': 'Hot products',
      '生日汇正在热销中': 'Hot sale of birthday party',
      '电子抵用券': 'E-voucher',
      '蛋糕面包西饼': 'Cake, bread and pastry',
      '生日汇商品分类': 'Product category of birthday party',
      '生日汇精选品牌': 'Handpicked brands of birthday party',
      '所有产品分类': 'All product categories',
      '去购物车': 'Go cart',
      '超重': '超重',
      '需支付运费': 'Freight to be paid',
      '内包邮': '内包邮',
      '当前重量': '当前重量：',
      '已达到包邮金额': 'Free delivery for X',
      '包邮': 'Free delivery',
      '还差': 'Balance',
      '取消': 'Cancel',
      '确定': 'Confirm',
      '价格': 'Price',
      '凑单商品': 'Add-on items',
      '东福超市': 'DF supermarket',
      '网易严选': 'Lifease',
      '小米有品': 'MI selection',
      '京东优选': 'JD preference',
      '图书': 'Books',
      '优选生活': 'Preferred life',
      '去结算': 'Settle now',
      '查看商品详情': 'View product details',
      '加入购物车成功': 'Successful',
      '回到顶部': 'Back to top',
      '活动导航': 'Navigation',
      '加入购物车': 'Add to shopping cart',
      '数量': 'Quantity',
      '规格': 'Specification',
      '售价': 'Selling price',
      '我知道了': 'I know',
      '购买数量从': '购买数量从',
      '由于商品的限购数量发生了变化': 'Purchase quantity has been transformed from X into X due to the change of limited purchase.',
      '改为了': 'Changed to',
      '由于商品的起购数量发生了变化': 'Purchase quantity has changed from X to X due to the change of min. quantity',
      '个商品发生了变化': 'Is changed',
      '购物车内的': 'Products within cart',
      '企业定制': 'Enterprise customization',
      '健康商城': 'Health shopping mall',
      '口腔健康': 'Mouth health',
      '体检预约': 'Medical examination appointment',
      '首页': 'Home',
      '退出账号': 'Exit',
      '个人中心': 'Me',
      '删除': 'Delete',
      '全部删除': 'Delete all',
      '最近搜过': 'Latest search',
      '福豆': 'FuDou',
      '个商品': 'product(s)',
      '约': 'About',
      '可用福利卡抵扣的商品': 'Deductible products by bonus card',
      '南京东路街道': '南京东路街道',
      '黄浦区': '黄浦区',
      '上海': 'Shanghai',
      '上海市': 'Shanghai',
      '搜索': 'Search',
      '微信版': 'Wechat version',
      '服务热线': 'hotline：',
      '卡劵使用指南': 'Guide to the use of card coupons',
      '购物车': 'Cart',
      '我的账户': 'My account',
      '商城首页': 'Mall',
      '注册': 'Register',
      '登录': 'Login',
      '退出登录': 'Exit',
      '请重新登录': 'Pls login again',
      '欢迎来到东方福利网': 'Welcome！',
      '东福乐影卡': '东福乐影卡',
      '东福生日汇': '东福生日汇',
      '东福超级卡': '东福超级卡',
      '东福产品': '东福产品',
      '常见问题': '常见问题',
      '退货政策': '退货政策',
      '售后服务': '售后服务',
      '配送说明': '配送说明',
      '支付方式': 'Mode of payment',
      '购买指南': '购买指南',
      '卡券使用指南': '卡券使用指南',
      '购物指南': '购物指南',
      '沪公网安备': 'H.G.W.A.B.No.31010502004928',
      '预付卡章程': 'Prepaid card rule',
      '违法和不良信息举报电话': 'Complaint call of illegal acts and malicious info.: 021-61352872',
      '隐私政策': 'Privacy policy',
      '增值电信业务经营许可证': 'Telecom value-added service business certificate: H.B2-20190068',
      '酒类商品零售许可证': 'Alcohol product retail license: H.M.J.Z.Zi.No. 1306030113004373',
      '出版物经营许可证': 'Publication business certificate: X.C.F.H.L.Zi.No. K7696',
      '第二类医疗器械经营备案凭证': 'Second category medical device operation registration certificate: H.M.S.Y.J.X.J.Y.B.No. 20190028',
      '上海东福网络科技有限公司': 'Shanghai Dongfu Network Technology Co., Ltd.',
      '微信扫一扫关注东福': '微信扫一扫  关注东福',
      '返回顶部': 'Top',
      '周一至周日': 'From Mon. to Sun.',
      '周一至周五': 'From Mon. to Fri.',
      '贴心客服热线': 'Customer service hotline',
      '在线客服': 'Online customer service',
      '东方福利网': 'DF',
      '重量': 'Weight',
      '选择新地址': 'Pls select new address',
      '送至': 'Deliver to',
      '品牌': 'Brand',
      '全部': 'All',
      '分类': 'CAT',
      '已选': 'Selected',
      '自动扣款': 'Auto deduction',
      '支付设置': 'Payment settings',
    },
    cn: {
      '抱歉您的订单提交失败': '抱歉，您的订单提交失败！',
      '编辑收货地址': '编辑收货地址',
      '新增收货地址': '新增收货地址',
      '当前已选城市': '当前已选城市:',
      '物流公司': '物流公司:',
      '快递编号': '快递编号:',
      '配送方式': '配送方式:',
      '内发货': '内发货',
      '至': '至',
      '现在下单': '现在下单，商品将在',
      '再想想': '再想想',
      '删除后将无法找回订单': '删除后将无法找回订单，您确认删除吗？',
      '删除订单': '删除订单',
      '更多': '更多',
      '专享价': '专享价',
      '京东优选分类': '京东优选分类',
      '楼层导航': '楼层导航',
      '营业时间': '营业时间:',
      '电话': '电话',
      '地址': '地址:',
      '使用微信扫码立即体验随心兑': '使用微信扫码 立即体验随心兑',
      '微信扫一扫': '微信扫一扫',
      '随心兑': '随心兑',
      '可用，需到店使用': '可用，需到店使用',
      '消费': '消费',
      '折': '折',
      '兑': '兑',
      '品牌故事': '品牌故事',
      '适用门店': '适用门店',
      '商品': '商品',
      '品牌详情': '品牌详情',
      '生日汇': '生日汇',
      '购买': '购买',
      '在线支付': '在线支付',
      '抵用券': '抵用券',
      '券': '券',
      '品牌介绍': '品牌介绍:',
      '图书分类': '图书分类',
      '起': '起',
      '查看更多': '查看更多',
      '热门推荐': '热门推荐',
      '起发货': '起发货',
      '热门商品': '热门商品',
      '生日汇正在热销中': '生日汇正在热销中',
      '电子抵用券': '电子抵用券',
      '蛋糕面包西饼': '蛋糕面包西饼',
      '生日汇商品分类': '生日汇商品分类',
      '生日汇精选品牌': '生日汇精选品牌',
      '所有产品分类': '所有产品分类',
      '去购物车': '去购物车',
      '超重': '超重',
      '需支付运费': '需支付运费',
      '内包邮': '内包邮',
      '当前重量': '当前重量：',
      '已达到包邮金额': '已达到包邮金额',
      '包邮': '包邮',
      '还差': '还差',
      '取消': '取消',
      '确定': '确定',
      '价格': '价格',
      '凑单商品': '凑单商品',
      '东福超市': '东福超市',
      '网易严选': '网易严选',
      '小米有品': '小米有品',
      '京东优选': '京东优选',
      '图书': '图书',
      '优选生活': '优选生活',
      '去结算': '去结算',
      '查看商品详情': '查看商品详情',
      '加入购物车成功': '加入购物车成功',
      '回到顶部': '回到顶部',
      '活动导航': '活动导航',
      '加入购物车': '加入购物车',
      '数量': '数量',
      '规格': '规格',
      '售价': '售价',
      '我知道了': '我知道了',
      '购买数量从': '购买数量从',
      '由于商品的限购数量发生了变化': '由于商品的限购数量发生了变化，所以购买数量从',
      '改为了': '改为了',
      '由于商品的起购数量发生了变化': '由于商品的起购数量发生了变化，所以购买数量从',
      '个商品发生了变化': '个商品发生了变化',
      '购物车内的': '购物车内的',
      '企业定制': '企业定制',
      '健康商城': '健康商城',
      '口腔健康': '口腔健康',
      '体检预约': '体检预约',
      '首页': '首页',
      '退出账号': '退出账号',
      '个人中心': '个人中心',
      '删除': '删除',
      '全部删除': '全部删除',
      '最近搜过': '最近搜过',
      '福豆': '福豆',
      '个商品': '个商品',
      '约': '约',
      '可用福利卡抵扣的商品': '可用 福利卡 抵扣的商品',
      '南京东路街道': '南京东路街道',
      '黄浦区': '黄浦区',
      '上海': '上海',
      '上海市': '上海市',
      '搜索': '搜索',
      '微信版': '微信版',
      '服务热线': '服务热线：',
      '卡劵使用指南': '卡劵使用指南',
      '购物车': '购物车',
      '我的账户': '我的账户',
      '商城首页': '商城首页',
      '注册': '注册',
      '登录': '登录',
      '退出登录': '退出登录',
      '请重新登录': '请重新登录',
      '欢迎来到东方福利网': '欢迎来到东方福利网！',
      '东福乐影卡': '东福乐影卡',
      '东福生日汇': '东福生日汇',
      '东福超级卡': '东福超级卡',
      '东福产品': '东福产品',
      '常见问题': '常见问题',
      '退货政策': '退货政策',
      '售后服务': '售后服务',
      '配送说明': '配送说明',
      '支付方式': '支付方式',
      '购买指南': '购买指南',
      '卡券使用指南': '卡券使用指南',
      '购物指南': '购物指南',
      '沪公网安备': '沪公网安备31010502004928号',
      '预付卡章程': '预付卡章程',
      '违法和不良信息举报电话': '违法和不良信息举报电话：021-61352872',
      '隐私政策': '隐私政策',
      '增值电信业务经营许可证': '增值电信业务经营许可证：沪B2-20190068',
      '酒类商品零售许可证': '酒类商品零售许可证：沪闵酒专字 第1306030113004373号',
      '出版物经营许可证': '出版物经营许可证：新出发沪零字第K7696号',
      '第二类医疗器械经营备案凭证': '第二类医疗器械经营备案凭证：沪闵食药监械经营备20190028号',
      '上海东福网络科技有限公司': '上海东福网络科技有限公司',
      '微信扫一扫关注东福': '微信扫一扫  关注东福',
      '返回顶部': '返回顶部',
      '周一至周日': '周一至周日',
      '周一至周五': '周一至周五',
      '贴心客服热线': '贴心客服热线',
      '在线客服': '在线客服',
      '东方福利网': '东方福利网',
      '重量': '重量',
      '选择新地址': '选择新地址',
      '送至': '送至',
      '品牌': '品牌',
      '全部': '全部',
      '分类': '分类:',
      '已选': '已选:',
      '自动扣款': '自动扣款',
      '支付设置': '支付设置',
    },
  },
  list: {
    en: {
      "页": "Page",
      '场演出': 'in total',
      '保存': 'Save',
      '使用': '使用',
      '个人信息': 'Personal information',
      '重新设置': 'Pls reset',
      '请重新设置': 'Pls reset',
      '本次开通失败': '本次开通失败！',
      '将为您开通免密设置': '将为您开通免密设置',
      '是否退出免密设置': '是否退出免密设置？',
      '确认关闭': '确认关闭？',
      '关闭免密抵扣后会增加下单时间': '关闭免密抵扣后, 会增加下单时间',
      '去设置': '去设置',
      '去绑定': '去绑定',
      '请先绑定': 'Pls bind firstly',
      '您还未绑定手机号': 'You haven’t yet bound phone number',
      '时无需支付密码下单更便捷': '时，无需支付密码，下单更便捷',
      '抵扣金额': '抵扣金额',
      '免密抵扣': 'password-free deduction',
      '基础信息': '基础信息',
      '快去新建吧': 'Create now!',
      '您还没有收货地址': 'You don’t have delivery address~',
      '联系方式': '联系方式',
      '个': 'individual',
      '个收货地址最多可创建': '个收货地址，最多可创建',
      '您已创建': '您已创建',
      '是否删除该商品': 'Do you want to delete this product',
      '参加满减活动': 'Participate in the cash-back activity',
      '可享满': 'Cash back',
      '再买': 'Get',
      '减': 'back',
      '已享满': 'Cash back',
      '去凑单': 'Add-on items',
      '包邮还差': 'Free delivery Balance',
      '满': 'cash',
      '赶紧去逛逛': '赶紧去逛逛！',
      '您的购物车还是空的哦': 'Your shopping cart is empty.',
      '礼包商品如下': 'Gift bas as follows',
      '如需与优选商品一起结算': '如需与优选商品一起结算，可以使用【超级卡】或第三方支付',
      '限购买礼包商品': 'Gift bag only',
      '东福礼品卡': 'DF gift card',
      '您的': 'Your',
      '不清空': 'Do not clear',
      '您要清空失效商品吗': 'Do you want to clear the expired products?',
      '不删除': 'Do not delete',
      '您要删除选中的商品吗': 'Do you want to delete the selected product?',
      '合计不含运费': 'Total (excluding freight)',
      '已选商品': 'selected',
      '清空失效商品': 'Clear the expired products',
      '删除选中商品': 'Delete selected products',
      '全选': 'Select all',
      '我的购物车': 'My shopping cart',
      '切换城市': 'Change city',
      '仅看有货': 'Only view available',
      '清空': 'Clear',
      '热度': 'Popularity',
      '新品': 'New arrival',
      '销量': 'Sales volume',
      '综合': 'Overall',
      '返回上一步': 'Back',
      '抱歉没有找到相关的商品哦': '抱歉~没有找到相关的商品哦~',
      '商品列表': 'Product list',
      '逛逛首页': 'Go to the homepage',
      '上一页': 'Previous page',
      '抱歉商品过期不存在': '抱歉，商品过期不存在~',
      '起购': 'Minimum',
      '限购': 'Limited purchase',
      '最近浏览': 'Latest browsing history',
      '补货中': 'Replenishing',
      '抢光了': 'Sellout',
      '常用地址': 'Usual address',
      '继续购物': 'Continue to buy',
      '商品详情': 'Product details',
      '说明一个礼': 'Note: one gift box contains two. Quantities limited: rain check',
      '赠品': 'Free gifts',
      '不计重量': 'Weight excluded',
      '商品以非专享价进行结算': '件), 若下单数量超过限购数时，商品以非专享价进行结算',
      '件享受优惠专享价剩余可购': '件享受优惠(专享价剩余可购',
      '购买不超过': '购买不超过',
      '专享限购': 'Exclusive sale',
      '满减': 'Cash back',
      '优惠': 'Discount',
      '商品编码': 'Product code',
      '限时特惠': 'Limited offer',
      '件': 'Pcs',
      '仅剩': 'left',
      '东福抢购': 'DONGFANGFULI.COM flash offer',
      '天': 'Day',
      '距离结束': 'Only left',
      '限时特价': 'Flash sale',
      '起开始发货': '起开始发货',
      '现在下单': 'Order now',
      '继续逛逛': 'Continue shopping',
      '赶紧去购物吧': 'go shopping now!',
      '还没有您的订单哦': 'You don’t have orders',
      '剩余': 'left',
      '仓库编码': 'Warehouse code',
      '订单号': 'Order number',
      '操作': 'Operation',
      '历史订单': 'Order history',
      '退款相关': 'Refund related',
      '待支付': 'To be paid',
      '全部订单': 'All orders',
      '客服电话请忽略按的提示音内容': '客服电话: 400 618 2999-1（请忽略按1的提示音内容，直接按1咨询即可） 周一至周日9:00-21:00',
      '联系客服': '联系客服',
      '申请退款': 'Apply for a refund',
      '查看物流': 'View logistics',
      '以上为最新跟踪信息': '以上为最新跟踪信息',
      '查看全部': 'view all',
      '包裹': '包裹',
      '个包裹发出': '个包裹发出',
      '该订单拆成': '该订单拆成',
      '取消订单': 'Cancel order',
      '下单时间': 'Order time',
      '订单编号': 'Order No.',
      '邮编': '邮编：',
      '退款方式': 'Refund mode',
      '退款明细': 'Refund details',
      '状态': 'Status',
      '支付时间': 'Payment time',
      '支付金额/次额': 'Payment amount/number',
      '东方福利卡号': 'DONGFANGFULI.COM card no.',
      '支付明细': 'Payment details',
      '继续支付': 'Continue to pay',
      '订单详情': 'Order details',
      '以上商品本卡暂不支持购买': 'This card is unavailable for above products',
      '起邮管局通知': '2018.09.01起，邮管局通知：所有快递物流信息上收件人以及寄件人信息禁止出现X先生/X小姐等字样，务必实名填写。请您实名填写收件信息，否则不予发货，谢谢配合！',
      '失效': 'Invalid',
      '件商品小计': 'products，subtotal',
      '共件商品': '共件商品',
      '进入提交订单页,选择相应的优惠券并使用': '进入提交订单页,选择相应的优惠券并使用',
      '扫描下方二维码': 'Scan QR code below',
      '通过以下方式': 'Open "scan" via the following methods',
      '返回修改': 'Return for modification',
      '生日牌内容': 'Birthday plate content',
      '提交订单': 'Submit Order',
      '运费收取规则': 'Freight collection rule',
      '续重运费': 'Additional weight',
      '基础运费': 'Basic freight',
      '件商品商品总价': 'products Total price of products',
      '商品总价': 'Total price of products',
      '件商品': 'products',
      '共': 'Pcs',
      '点我扫码': 'scan the QR code to get your special offer',
      '张优惠券可以在本笔订单使用': '张优惠券可以在本笔订单使用',
      '有': 'Expiry',
      '张优惠券': '张优惠券',
      '您共有': '您共有',
      '自动扣款': 'Auto deduction',
      '支付设置': 'Payment settings',
      '支付成功': 'Successful',

    },
    cn: {
      '场演出': '场演出',
      '保存': '保存',
      '使用': '使用',
      '个人信息': '个人信息',
      '重新设置': '重新设置',
      '请重新设置': '请重新设置',
      '本次开通失败': '本次开通失败！',
      '将为您开通免密设置': '将为您开通免密设置',
      '是否退出免密设置': '是否退出免密设置？',
      '确认关闭': '确认关闭？',
      '关闭免密抵扣后会增加下单时间': '关闭免密抵扣后, 会增加下单时间',
      '去设置': '去设置',
      '去绑定': '去绑定',
      '请先绑定': '请先绑定',
      '您还未绑定手机号': '您还未绑定手机号',
      '时无需支付密码下单更便捷': '时，无需支付密码，下单更便捷',
      '抵扣金额': '抵扣金额',
      '免密抵扣': '免密抵扣：',
      '基础信息': '基础信息',
      '快去新建吧': '快去新建吧！',
      '您还没有收货地址': '您还没有收货地址~',
      '联系方式': '联系方式',
      '个': '个',
      '个收货地址最多可创建': '个收货地址，最多可创建',
      '您已创建': '您已创建',
      '是否删除该商品': '是否删除该商品?',
      '参加满减活动': '参加满减活动',
      '可享满': '可享满',
      '再买': '再买',
      '减': '减',
      '已享满': '已享满',
      '去凑单': '去凑单',
      '包邮还差': '包邮，还差',
      '满': '满',
      '赶紧去逛逛': '赶紧去逛逛！',
      '您的购物车还是空的哦': '您的购物车还是空的哦~',
      '礼包商品如下': '礼包商品如下:',
      '如需与优选商品一起结算': '如需与优选商品一起结算，可以使用【超级卡】或第三方支付',
      '限购买礼包商品': '限购买礼包商品',
      '东福礼品卡': '东福礼品卡',
      '您的': '您的',
      '不清空': '不清空',
      '您要清空失效商品吗': '您要清空失效商品吗?',
      '不删除': '不删除',
      '您要删除选中的商品吗': '您要删除选中的商品吗?',
      '合计不含运费': '合计（不含运费）：',
      '已选商品': '已选商品',
      '清空失效商品': '清空失效商品',
      '删除选中商品': '删除选中商品',
      '全选': '全选',
      '我的购物车': '我的购物车',
      '切换城市': '切换城市',
      '仅看有货': '仅看有货',
      '清空': '清空',
      '热度': '热度',
      '新品': '新品',
      '销量': '销量',
      '综合': '综合',
      '返回上一步': '返回上一步',
      '抱歉没有找到相关的商品哦': '抱歉~没有找到相关的商品哦~',
      '商品列表': '商品列表',
      '逛逛首页': '逛逛首页',
      '上一页': '上一页',
      '抱歉商品过期不存在': '抱歉，商品过期不存在~',
      '起购': '起购',
      '限购': '限购',
      '最近浏览': '最近浏览',
      '补货中': '补货中',
      '抢光了': '抢光了',
      '常用地址': '常用地址',
      '继续购物': '继续购物',
      '商品详情': '商品详情',
      '说明一个礼': '说明：一个礼盒赠两张，数量有限，赠完即止',
      '赠品': '赠品',
      '不计重量': '不计重量',
      '商品以非专享价进行结算': '件), 若下单数量超过限购数时，商品以非专享价进行结算',
      '件享受优惠专享价剩余可购': '件享受优惠(专享价剩余可购',
      '购买不超过': '购买不超过',
      '专享限购': '专享限购',
      '满减': '满减',
      '优惠': '优惠',
      '商品编码': '商品编码',
      '限时特惠': '限时特惠',
      '件': '件',
      '仅剩': '仅剩',
      '东福抢购': '东福抢购',
      '天': '天',
      '距离结束': '距离结束',
      '限时特价': '限时特价',
      '起开始发货': '起开始发货',
      '现在下单': '现在下单',
      '继续逛逛': '继续逛逛',
      '赶紧去购物吧': '赶紧去购物吧！',
      '还没有您的订单哦': '还没有您的订单哦~',
      '剩余': '剩余',
      '仓库编码': '仓库编码:',
      '订单号': '订单号',
      '操作': '操作',
      '历史订单': '历史订单',
      '退款相关': '退款相关',
      '待支付': '待支付',
      '全部订单': '全部订单',
      '客服电话请忽略按的提示音内容': '客服电话: 400 618 2999-1（请忽略按1的提示音内容，直接按1咨询即可） 周一至周日9:00-21:00',
      '联系客服': '联系客服',
      '申请退款': '申请退款',
      '查看物流': '查看物流',
      '以上为最新跟踪信息': '以上为最新跟踪信息',
      '查看全部': '查看全部',
      '包裹': '包裹',
      '个包裹发出': '个包裹发出',
      '该订单拆成': '该订单拆成',
      '取消订单': '取消订单',
      '下单时间': '下单时间',
      '订单编号': '订单编号',
      '邮编': '邮编：',
      '退款方式': '退款方式',
      '退款明细': '退款明细',
      '状态': '状态',
      '支付时间': '支付时间',
      '支付金额/次额': '支付金额/次额',
      '东方福利卡号': '东方福利卡号',
      '支付明细': '支付明细',
      '继续支付': '继续支付',
      '订单详情': '订单详情',
      '以上商品本卡暂不支持购买': '以上商品本卡暂不支持购买',
      '起邮管局通知': '2018.09.01起，邮管局通知：所有快递物流信息上收件人以及寄件人信息禁止出现X先生/X小姐等字样，务必实名填写。请您实名填写收件信息，否则不予发货，谢谢配合！',
      '失效': '失效',
      '件商品小计': '件商品，小计:',
      '共件商品': '共件商品',
      '进入提交订单页,选择相应的优惠券并使用': '进入提交订单页,选择相应的优惠券并使用',
      '扫描下方二维码': '扫描下方二维码',
      '通过以下方式': '通过以下方式，打开“扫一扫”',
      '返回修改': '返回修改',
      '生日牌内容': '生日牌内容:',
      '提交订单': '提交订单',
      '运费收取规则': '运费收取规则',
      '续重运费': '续重运费',
      '基础运费': '基础运费',
      '件商品商品总价': '件商品，商品总价',
      '商品总价': '商品总价',
      '件商品': '件商品',
      '共': '共',
      '点我扫码': '点我扫码，立享优惠',
      '张优惠券可以在本笔订单使用': '张优惠券可以在本笔订单使用',
      '有': 'Expiry',
      '张优惠券': '张优惠券',
      '您共有': '您共有',
      '自动扣款': '自动扣款',
      '支付设置': '支付设置',
      '支付成功': '支付成功',
    },
  },
  common: {
    cn: {
      '电影票、话剧票、健身': '电影票、话剧票、健身...',
      '请添加或选择用户收货地址': '请添加或选择用户收货地址',
      '其他': '其他',
      '分类': '分类',
      '语言': '简体中文',
      '消息': '消息',
      '企业首页': '企业首页',
    },
    en: {
      '电影票、话剧票、健身': 'Movie tickets, drama tickets, fitness...',
      '请添加或选择用户收货地址': 'Please add or select the shipping address of the user',
      '其他': 'Others',
      '分类': ' CAT',
      '语言': 'English',
      '消息': 'Message',
      '企业首页': 'Home',
    },
  },
};
